import React from "react";
import EmptyMessageLogo from "../../../assets/img/emptyMessageLogo.svg"
import classes from './empty-message.module.css';


class EmptyMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imagesize: 200
        }

        }
  
        componentDidMount(){
            var imgwidth = this.props.size;
            if(imgwidth == "small" ){
             this.setState({imagesize:100});
            }else{
                this.setState({imagesize:200});
            }

        }
 

  render() {
   
   return (
      <div className={this.props.size=="small"? classes.EmptyMsgGridSmall : classes.EmptyMsgGrid}>
      { this.props.noimage ? <div></div> :
        this.props.image ?
      <img src={this.props.image} alt="image not found" style={{width:this.state.imagesize}}/> : 
      <img src={EmptyMessageLogo} style={{width:this.state.imagesize}}/> 
      }
      <div className={classes.MsgText}>{this.props.text} </div>
      </div>
    );
  }
}

export default EmptyMessage;